import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import { Button, Card, CardContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface EditableCardProps {
	title?: string;
	children: React.ReactNode;
	className?: string;
	modalContent?: React.ReactNode;
	showActions?: boolean;
	readonly?: boolean;
	handleSave?: () => void;
	onEdit?: () => void;
}

export const EditableCard = ({
	title,
	children,
	className,
	readonly = false,
	onEdit,
}: EditableCardProps) => {
	const { t } = useTranslation();

	return (
		<>
			<Card
				className={className}
				sx={{
					borderRadius: '15px',
					boxShadow: '0px 2px 6px 0px #00000040',
					backgroundColor: 'white',
					padding: '20px',
				}}
			>
				<CardContent>
					<div className="flex justify-between items-center mb-4">
						<Typography
							sx={{
								color: '#343A40',
								fontFamily: 'Roboto',
								fontSize: '20px',
								fontWeight: '600',
								lineHeight: '140%',
							}}
							variant="h6"
							component="div"
						>
							{title}
						</Typography>
						{!readonly && (
							<Button
								sx={{
									borderRadius: '8px',
									background: '#F8F9FA',
									height: '34px',
									padding: '5px 10px',
									alignItems: 'center',
									color: '#00AB89',
									fontFamily: 'Roboto',
									fontSize: '16px',
									fontStyle: 'normal',
									fontWeight: 600,
									lineHeight: '140%',
									boxShadow: 'unset',
									textTransform: 'capitalize',
								}}
								variant="contained"
								startIcon={<CreateOutlinedIcon />}
								onClick={onEdit}
							>
								{t('editable')}
							</Button>
						)}
					</div>
					{children}
				</CardContent>
			</Card>
		</>
	);
};
